import {GuruEntity} from '../model/guru-entity';
import {Sku} from '../model/sku';
import {SfrEntry} from '../model/sfr-entry';

export class SelectionUtils {

  static noChangeAllowableValue = 'NoChangeMadeInMassUpdateDialog';

  static getEntity(entities: GuruEntity[], entityName: string): GuruEntity {
    if (entities) {
      const filtered = entities.filter(entity => entity.Name === entityName);
      if (filtered && filtered.length === 1) {
        return filtered[0];
      }
    }
    return null!;
  }

  static isOem(prnField1: string): boolean {
    return !!(prnField1 && (prnField1.startsWith('C') || prnField1.startsWith('D') || prnField1.startsWith('U')) && 'CLM' !== prnField1);
  }

  static getConfigurationPrice(skus: Sku[], sfrEntries: SfrEntry[]): number {
    if ((skus?.length || 0) === 0) {
      return 0;
    }
    const skuPrice = skus.map(sku => SelectionUtils.getSkuPrice(sku, sfrEntries))
      .reduce((accumulator, currentValue) => accumulator + currentValue);
    let sfrPrice = 0;
    if ((sfrEntries?.length || 0) > 0) {
      const nonIgnoredPrices: number[] = sfrEntries.filter(sfr => !sfr.ignore).map(sfr => sfr.price);
      if (nonIgnoredPrices && nonIgnoredPrices.length > 0) {
        sfrPrice = nonIgnoredPrices.reduce((accumulator, currentValue) => accumulator + currentValue);
      }
    }
    return skuPrice + sfrPrice;
  }

  private static getSkuPrice(sku: Sku, sfrEntries: SfrEntry[]): number {
    const sfrs: SfrEntry[] = sfrEntries && sfrEntries.length > 0 ? sfrEntries : [];
    const overriddenSlots: string[] = sfrs.filter(sfr => !sfr.ignore).flatMap(sfr => sfr.skus);
    return overriddenSlots.indexOf(sku.name) < 0 ? sku.price : 0;
  }

}
